<template>
  <h5>{{ paso }}</h5>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters({
        paso: 'pasos/getPasoActual'
      })
    }
  }
</script>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// src/components/PasoActual.vue